import { Typography } from '@mui/material';
import React from 'react';

export const parseHtmlString = (
  html: string,
  typographyVariant?: 'body1' | 'body2'
): React.ReactNode => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  const renderNode = (node: ChildNode): React.ReactNode => {
    if (node.nodeType === Node.TEXT_NODE) {
      return node.textContent;
    }

    if (node.nodeType !== Node.ELEMENT_NODE) {
      return null;
    }

    const element = node as HTMLElement;
    const children = Array.from(element.childNodes).map(renderNode);

    switch (element.tagName.toLowerCase()) {
      case 'p':
        return (
          <Typography
            key={element.outerHTML}
            variant={typographyVariant || 'body2'}
          >
            {children}
          </Typography>
        );
      case 'h1':
        return (
          <Typography key={element.outerHTML} variant="h1">
            {children}
          </Typography>
        );
      case 'ul':
        return (
          <ul
            key={element.outerHTML}
            style={{ marginBottom: 0, marginTop: '16px' }}
          >
            {children}
          </ul>
        );
      case 'li':
        return <li key={element.outerHTML}>{children}</li>;
      case 'strong':
        return (
          <span key={element.outerHTML} style={{ fontWeight: '600' }}>
            {children}
          </span>
        );
      case 'em':
        return (
          <span key={element.outerHTML} style={{ fontStyle: 'italic' }}>
            {children}
          </span>
        );
      default:
        return children;
    }
  };

  return Array.from(doc.body.childNodes).map(renderNode);
};
